(function () {
  if (!window.__amuminCrossMarketSwitchBound) {
    document.addEventListener(
      "click",
      async (event) => {
        const link = event.target.closest("a[data-cross-market-href]");
        if (!link) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        const targetHref = link.getAttribute("data-cross-market-href");
        const fallbackHref = "/";

        if (!targetHref) {
          window.location.href = fallbackHref;
          return;
        }

        // If this isn't an NL market jump, keep native navigation behavior.
        if (targetHref.startsWith("/en") || targetHref.startsWith("/de") || targetHref.startsWith("/fr") || targetHref.startsWith("/es") || targetHref.startsWith("/tr") || targetHref.startsWith("/ar") || targetHref.startsWith("/zh")) {
          window.location.href = targetHref;
          return;
        }

        try {
          const controller = new AbortController();
          const timeoutId = window.setTimeout(() => controller.abort(), 1500);

          const response = await fetch(targetHref, {
            method: "HEAD",
            cache: "no-store",
            credentials: "same-origin",
            redirect: "manual",
            signal: controller.signal,
          });

          window.clearTimeout(timeoutId);

          // 2xx: exists, 3xx: redirected path still valid flow, 405: HEAD not supported.
          if (response.ok || (response.status >= 300 && response.status < 400) || response.status === 405) {
            window.location.href = targetHref;
            return;
          }

          window.location.href = fallbackHref;
        } catch (error) {
          window.location.href = fallbackHref;
        }
      },
      true
    );

    window.__amuminCrossMarketSwitchBound = true;
  }

  const config = window.amuminLocaleSuggestionConfig;

  if (!config) {
    return;
  }

  const DAY_MS = 24 * 60 * 60 * 1000;
  const storageKey = config.storageKey || "amumin-locale-suggestion-v1";
  const localePrefixes = {
    en: "/en",
    nl: "",
    de: "/de",
    fr: "/fr",
    es: "/es",
    tr: "/tr",
    ar: "/ar",
    "zh-CN": "/zh",
  };

  function safeRead() {
    try {
      const raw = window.localStorage.getItem(storageKey);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function safeWrite(value) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(value));
    } catch (error) {
      return null;
    }
  }

  // Preserve the live variant/query, while keeping the server's translated path.
  const manualLinkSelector = "a.amumin-langpicker__link, a.amumin-mobile-lang__link";
  let suggestionRoot = null;

  function refreshManualLanguageLink(event) {
    const link = event.target && typeof event.target.closest === "function"
      ? event.target.closest(manualLinkSelector)
      : null;
    if (!link || event.defaultPrevented) return null;

    const locale = Object.keys(localePrefixes).find(
      (value) => value.toLowerCase() === (link.getAttribute("hreflang") || "").toLowerCase()
    );
    const href = link.getAttribute("href");
    if (!locale || !href) return null;

    try {
      const target = new URL(href, window.location.href);
      if (target.origin !== window.location.origin ||
          !["http:", "https:"].includes(target.protocol) || target.username || target.password) {
        return null;
      }
      link.setAttribute("href", `${target.pathname}${window.location.search}${window.location.hash}`);
      return locale;
    } catch (error) {
      return null;
    }
  }

  function rememberManualLanguage(event) {
    const isActivation = (event.type === "click" && event.button === 0) ||
      (event.type === "auxclick" && event.button === 1);
    if (!isActivation) return;
    const locale = refreshManualLanguageLink(event);
    if (!locale) return;

    safeWrite({
      decision: "manual",
      locale,
      expiresAt: Date.now() + (config.ttlDays || 30) * DAY_MS,
    });
    if (suggestionRoot) suggestionRoot.remove();
    // No preventDefault: normal links retain Enter, modifier and new-tab behavior.
  }

  document.addEventListener("pointerdown", refreshManualLanguageLink, true);
  document.addEventListener("focusin", refreshManualLanguageLink, true);
  document.addEventListener("contextmenu", refreshManualLanguageLink, true);
  document.addEventListener("click", rememberManualLanguage, true);
  document.addEventListener("auxclick", rememberManualLanguage, true);

  function normalizeLocale(candidate) {
    if (!candidate) {
      return null;
    }

    const value = candidate.toLowerCase();

    if (value.startsWith("nl")) return "nl";
    if (value.startsWith("de")) return "de";
    if (value.startsWith("fr")) return "fr";
    if (value.startsWith("es")) return "es";
    if (value.startsWith("tr")) return "tr";
    if (value.startsWith("ar")) return "ar";
    if (value.startsWith("zh")) return "zh-CN";
    if (value.startsWith("en")) return "en";

    return null;
  }

  function getBrowserTargetLocale() {
    const candidates = Array.isArray(navigator.languages) && navigator.languages.length
      ? navigator.languages
      : [navigator.language];

    for (const candidate of candidates) {
      const locale = normalizeLocale(candidate);

      if (locale) {
        return locale;
      }
    }

    return null;
  }

  function normalizePath(pathname) {
    const prefixes = Object.values(localePrefixes)
      .filter(Boolean)
      .sort((left, right) => right.length - left.length);

    for (const prefix of prefixes) {
      if (pathname === prefix) {
        return "/";
      }

      if (pathname.startsWith(`${prefix}/`)) {
        return pathname.slice(prefix.length) || "/";
      }
    }

    return pathname || "/";
  }

  function buildTargetUrl(locale) {
    const prefix = localePrefixes[locale];
    const normalizedPath = normalizePath(window.location.pathname);
    const path = prefix ? `${prefix}${normalizedPath === "/" ? "" : normalizedPath}` : normalizedPath;

    return `${path || "/"}${window.location.search}${window.location.hash}`;
  }

  function shouldSkip(targetLocale) {
    if (!targetLocale || targetLocale === config.currentLocale) {
      return true;
    }

    if (false /* /nl-nl legacy check removed post-cutover 2026-05-12 */) {
      return true;
    }

    const stored = safeRead();

    if (!stored) {
      return false;
    }

    if (!stored.expiresAt || stored.expiresAt < Date.now()) {
      return false;
    }

    return true;
  }

  function createSuggestion(targetLocale) {
    const targetLabel = (config.localeLabels || {})[targetLocale] || targetLocale;
    const root = document.createElement("aside");
    suggestionRoot = root;
    root.className = "amumin-locale-suggestion";
    root.setAttribute("role", "dialog");
    root.setAttribute("aria-live", "polite");

    root.innerHTML = `
      <button type="button" class="amumin-locale-suggestion__close" aria-label="${config.messages.closeLabel}">&times;</button>
      <span class="amumin-locale-suggestion__eyebrow">${config.messages.eyebrow}</span>
      <h2 class="amumin-locale-suggestion__title">${config.messages.title}</h2>
      <p class="amumin-locale-suggestion__body">${config.messages.bodyPrefix} <strong>${targetLabel}</strong>.</p>
      <div class="amumin-locale-suggestion__actions">
        <button type="button" class="amumin-locale-suggestion__action amumin-locale-suggestion__action--primary">${config.messages.switchLabel}</button>
        <button type="button" class="amumin-locale-suggestion__action amumin-locale-suggestion__action--secondary">${config.messages.stayLabel}</button>
      </div>
    `;

    const dismiss = () => {
      safeWrite({
        decision: "dismissed",
        locale: config.currentLocale,
        expiresAt: Date.now() + (config.ttlDays || 30) * DAY_MS,
      });
      root.remove();
    };

    root.querySelector(".amumin-locale-suggestion__close").addEventListener("click", dismiss);
    root.querySelector(".amumin-locale-suggestion__action--secondary").addEventListener("click", dismiss);
    root.querySelector(".amumin-locale-suggestion__action--primary").addEventListener("click", () => {
      safeWrite({
        decision: "switched",
        locale: targetLocale,
        expiresAt: Date.now() + (config.ttlDays || 30) * DAY_MS,
      });
      window.location.href = buildTargetUrl(targetLocale);
    });

    document.body.appendChild(root);
  }

  function init() {
    if (config.disableOnPaths && config.disableOnPaths.some((prefix) => window.location.pathname.startsWith(prefix))) {
      return;
    }

    const targetLocale = getBrowserTargetLocale();

    if (shouldSkip(targetLocale)) {
      return;
    }

    createSuggestion(targetLocale);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();

(function () {
  const DETECTION_CACHE_KEY = "amumin-detected-country-v1";
  const SYNC_CACHE_KEY = "amumin-country-sync-v1";
  const DETECTION_TTL_MS = 6 * 60 * 60 * 1000;
  const NL_PREFIX = "/";

  function normalizeCountry(candidate) {
    const value = String(candidate || "").trim().toUpperCase();
    return /^[A-Z]{2}$/.test(value) ? value : null;
  }

  function safeReadJSON(storage, key) {
    try {
      const raw = storage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function safeWriteJSON(storage, key, value) {
    try {
      storage.setItem(key, JSON.stringify(value));
    } catch (error) {
      return null;
    }
  }

  function getCurrentCountry() {
    const input = document.querySelector("input[name='country_code']");
    if (input && input.value) {
      return normalizeCountry(input.value);
    }

    const cookieMatch = document.cookie.match(/(?:^|;\s*)localization=([^;]+)/);
    if (cookieMatch && cookieMatch[1]) {
      return normalizeCountry(decodeURIComponent(cookieMatch[1]));
    }

    return null;
  }

  function toRelativePath(urlLike) {
    try {
      const resolved = new URL(urlLike, window.location.origin);
      if (resolved.origin !== window.location.origin) {
        return null;
      }

      return `${resolved.pathname}${resolved.search}${resolved.hash}`;
    } catch (error) {
      return null;
    }
  }

  function normalizePathname(pathname) {
    const value = String(pathname || "/");
    if (value === "/") return "/";
    return value.replace(/\/+$/, "") || "/";
  }

  function buildSafeReturnTo() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const blocked = new Set(["preview_theme_id", "_fd", "_sc", "_ab", "pb"]);

    for (const key of blocked) {
      params.delete(key);
    }

    const query = params.toString();
    return `${url.pathname}${query ? `?${query}` : ""}`;
  }

  function isCheckoutPath(pathname) {
    const normalized = normalizePathname(pathname);
    return (
      normalized === "/checkout" ||
      normalized.startsWith("/checkout/") ||
      normalized.startsWith("/checkouts")
    );
  }

  function isCartPath(pathname) {
    return normalizePathname(pathname) === "/cart";
  }

  function makeNlPath(pathname, search = "", hash = "") {
    // Post-cutover 2026-05-12: NL is on root, so no prefix to add.
    // Returning the path unchanged turns rewriteCheckoutHrefForNl and
    // rewriteFormActionForNl into no-ops, which is the desired behaviour.
    return `${normalizePathname(pathname)}${search}${hash}`;
  }

  function rewriteCheckoutHrefForNl(href) {
    const relative = toRelativePath(href);
    if (!relative) {
      return null;
    }

    const resolved = new URL(relative, window.location.origin);
    if (!isCheckoutPath(resolved.pathname)) {
      return null;
    }

    return makeNlPath(resolved.pathname, resolved.search, resolved.hash);
  }

  function rewriteFormActionForNl(action) {
    const relative = toRelativePath(action || "/cart");
    if (!relative) {
      return null;
    }

    const resolved = new URL(relative, window.location.origin);
    if (isCartPath(resolved.pathname)) {
      return makeNlPath(resolved.pathname, resolved.search, resolved.hash);
    }

    if (isCheckoutPath(resolved.pathname)) {
      return makeNlPath(resolved.pathname, resolved.search, resolved.hash);
    }

    return null;
  }

  function rewriteCheckoutEntrypointsForNl(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll("a[href]").forEach((anchor) => {
      const rewritten = rewriteCheckoutHrefForNl(anchor.getAttribute("href"));
      if (rewritten) {
        anchor.setAttribute("href", rewritten);
      }
    });

    root.querySelectorAll("form[action]").forEach((form) => {
      const hasCheckoutSubmit =
        form.querySelector("button[name='checkout'], input[name='checkout']") ||
        form.querySelector("button[formaction*='/checkout'], input[formaction*='/checkout']");

      if (!hasCheckoutSubmit) {
        return;
      }

      const rewrittenAction = rewriteFormActionForNl(form.getAttribute("action"));
      if (rewrittenAction) {
        form.setAttribute("action", rewrittenAction);
      }

      form
        .querySelectorAll("button[formaction], input[formaction]")
        .forEach((submitter) => {
          const rewritten = rewriteFormActionForNl(submitter.getAttribute("formaction"));
          if (rewritten) {
            submitter.setAttribute("formaction", rewritten);
          }
        });
    });
  }

  async function detectCountry() {
    const cached = safeReadJSON(window.localStorage, DETECTION_CACHE_KEY);
    if (cached && cached.country && cached.expiresAt > Date.now()) {
      return cached.country;
    }

    const response = await fetch("/browsing_context_suggestions.json", {
      method: "GET",
      credentials: "same-origin",
      cache: "no-store",
    });

    if (!response.ok) {
      return null;
    }

    const data = await response.json();
    const detected =
      normalizeCountry(data?.detected_values?.country?.handle) ||
      normalizeCountry(data?.detected_values?.country_code);

    if (detected) {
      safeWriteJSON(window.localStorage, DETECTION_CACHE_KEY, {
        country: detected,
        expiresAt: Date.now() + DETECTION_TTL_MS,
      });
    }

    return detected;
  }

  function alreadySynced(country) {
    const cached = safeReadJSON(window.sessionStorage, SYNC_CACHE_KEY);
    return Boolean(cached && cached.country === country && cached.synced === true);
  }

  function markSynced(country) {
    safeWriteJSON(window.sessionStorage, SYNC_CACHE_KEY, {
      country,
      synced: true,
      at: Date.now(),
    });
  }

  async function syncCountrySilently(country) {
    if (!country || alreadySynced(country)) {
      return;
    }

    const localeInput = document.querySelector("input[name='locale_code']");
    const params = new URLSearchParams();
    params.set("form_type", "localization");
    params.set("utf8", "✓");
    params.set("_method", "put");
    params.set("return_to", buildSafeReturnTo());
    params.set("country_code", country);
    if (localeInput && localeInput.value) {
      params.set("locale_code", localeInput.value);
    }

    await fetch("/localization", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: params.toString(),
      keepalive: true,
      redirect: "follow",
    });

    markSynced(country);
  }

  function bindCheckoutClickRewrite(targetCountry) {
    document.addEventListener(
      "click",
      (event) => {
        if (targetCountry !== "NL") return;

        const link = event.target.closest("a[href]");
        if (!link) return;

        const rewritten = rewriteCheckoutHrefForNl(link.getAttribute("href"));
        if (!rewritten) return;

        event.preventDefault();
        event.stopPropagation();
        window.location.href = rewritten;
      },
      true
    );
  }

  function bindCheckoutSubmitRewrite(targetCountry) {
    document.addEventListener(
      "submit",
      (event) => {
        if (targetCountry !== "NL") return;

        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        const submitter = event.submitter;
        const hasCheckoutIntent =
          (submitter && String(submitter.getAttribute("name") || "").toLowerCase() === "checkout") ||
          Boolean(form.querySelector("button[name='checkout'], input[name='checkout']"));

        if (!hasCheckoutIntent) return;

        const rewrittenAction = rewriteFormActionForNl(form.getAttribute("action"));
        if (rewrittenAction) {
          form.setAttribute("action", rewrittenAction);
        }

        if (submitter && submitter.hasAttribute("formaction")) {
          const rewrittenSubmitterAction = rewriteFormActionForNl(
            submitter.getAttribute("formaction")
          );
          if (rewrittenSubmitterAction) {
            submitter.setAttribute("formaction", rewrittenSubmitterAction);
          }
        }
      },
      true
    );
  }

  function observeDynamicCheckoutEntrypoints(targetCountry) {
    if (targetCountry !== "NL" || !window.MutationObserver) return;

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const addedNode of mutation.addedNodes) {
          if (!(addedNode instanceof HTMLElement)) continue;

          rewriteCheckoutEntrypointsForNl(addedNode);
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  async function init() {
    const currentCountry = getCurrentCountry();
    const detectedCountry = await detectCountry();
    if (!detectedCountry) return;

    if (detectedCountry !== currentCountry) {
      try {
        await syncCountrySilently(detectedCountry);
      } catch (error) {
        // continue gracefully
      }
    }

    if (detectedCountry === "NL") {
      rewriteCheckoutEntrypointsForNl(document);
      bindCheckoutClickRewrite(detectedCountry);
      bindCheckoutSubmitRewrite(detectedCountry);
      observeDynamicCheckoutEntrypoints(detectedCountry);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      init().catch(() => null);
    }, { once: true });
  } else {
    init().catch(() => null);
  }
})();


/* amumin-usp-runtime-fix: neutralize a stale cached homepage .center rule on the USP multicolumn only. */
(function () {
  if (window.__amuminUspRuntimeFixApplied) return;
  window.__amuminUspRuntimeFixApplied = true;

  var css = '.template-index [id*="multicolumn_zL948z"] .multicolumn-list__item.center{top:auto!important;left:auto!important;transform:none!important;text-align:center!important}.template-index [id*="multicolumn_zL948z"] .multicolumn-list__item.center .multicolumn-card{transform:none!important}';

  function injectStyle() {
    if (document.getElementById('amumin-usp-runtime-fix')) return;
    var style = document.createElement('style');
    style.id = 'amumin-usp-runtime-fix';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function resetItems() {
    injectStyle();
    document.querySelectorAll('.template-index [id*="multicolumn_zL948z"] .multicolumn-list__item.center').forEach(function (item) {
      item.style.setProperty('top', 'auto', 'important');
      item.style.setProperty('left', 'auto', 'important');
      item.style.setProperty('transform', 'none', 'important');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resetItems, { once: true });
  } else {
    resetItems();
  }

  window.addEventListener('load', resetItems, { once: true });
  setTimeout(resetItems, 1000);
})();
